import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

import Select from 'react-select';

import { toggleDialogBox } from '../../store/actions/commonActions';
import { getProjectsJSON } from '../../store/actions/projects/projectsActions';
import { handleFieldChange, createBudgetRequest } from '../../store/actions/projects/requestBudgetHoursActions';

class RequestBudgetForm extends Component {
  componentDidMount() {
    //var projectJSON = this.props.getProjectsJSON();
  }

  displayProjectsField = () => {
    let projectsParams = {};
    projectsParams.includeGenAdmin = false;
    const selectedWeek = this.props.timesheets.selectedWeek;
    if (Object.keys(selectedWeek).length > 0) {
      projectsParams.sheetStartDate = selectedWeek.start;
      projectsParams.sheetEndDate = selectedWeek.end;
    }
    
    let projectsJSON = this.props.getProjectsJSON(projectsParams) || [];

    return (
      <Row className="mt-3 ml-3 mr-3">
        <Col>
          <Form.Label>Project</Form.Label>
          <Select
            size="sm" 
            id="project_id" 
            onChange={(selectedOption) => {
              this.props.handleFieldChange(null, {project_id: selectedOption.value});
            }}
            options={projectsJSON}
          />
        </Col>
      </Row>
    )
  }

  render() { 
    return (
      <Modal id="t3-add-tasks-modal" show={this.props.common.toggleDialog} onHide={() => {
        this.props.toggleDialogBox(false);
        
      }} backdrop="static">
        <Modal.Header closeButton>
            <Modal.Title>Request Budget Hours</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          { this.displayProjectsField() }
          <Row className="mt-3 ml-3 mr-3">
            <Col>
              <Form.Group controlId="duration">
                <Form.Label>Hours to Add</Form.Label>
                <Form.Control 
                  type="number" 
                  step="0.01"
                  onChange={this.props.handleFieldChange} />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mt-3 ml-3 mr-3">
            <Col>
              <Form.Group controlId="reason">
                <Form.Label>Reason</Form.Label>
                <Form.Control 
                  as="textarea" 
                  rows="3" 
                  onChange={this.props.handleFieldChange}/>
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => {
            this.props.toggleDialogBox(false);
          }}>
              Cancel
          </Button>
          <Button variant="primary" type="button" onClick={() => {
            this.props.createBudgetRequest();
          }}>
              Add
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => ({
  common: state.common,
  timesheets: state.timesheets
})

const mapDispatchToProps = (dispatch) => {
  return {
    toggleDialogBox: (...args) => dispatch(toggleDialogBox(...args)),
    getProjectsJSON: (...args) => dispatch(getProjectsJSON(...args)),
    handleFieldChange: (...args) => dispatch(handleFieldChange(...args)),
    createBudgetRequest: () => dispatch(createBudgetRequest())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestBudgetForm)